import { useQuery } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { featureRequestRequesterApiRef } from '../../apis';

export const useFeatureRequestDetail = (id: string) => {
  const api = useApi(featureRequestRequesterApiRef);

  return useQuery({
    queryKey: ['feature-requests', 'requester-detail', id],
    queryFn: () => api.fetchDetail(id),
    enabled: !!id,
  });
};
